import React from 'react';
import "./NewDashboard.css";
import { Carousel } from 'primereact/carousel';
import { Image } from 'primereact/image';
import campaign1 from "../img/campaign_honkai_star_rail.jpg";
import campaign2 from "../img/campaign_warhammer.jpg";
import campaign3 from "../img/campaign_mob_control.jpg";
import NewInfluencerItem from "@/react_app/NewLatestItems/NewInfluencerItem/NewInfluencerItem";
import NewActiveCampaignItem from "@/react_app/NewLatestItems/NewActiveCampaignItem/NewActiveCampaignItem";
import { WarningCircleIcon } from "@/react_app/img/Icons";
import { Button } from "primereact/button";
import {Perspective} from "@/data/types";

const products = [
  {
    photo: campaign1,
    id: '65a77e8e227091f1b5fb382f',
  },
  {
    photo: campaign2,
    id: '64e388d07a1a9e42638d4191',
  },
  {
    photo: campaign3,
    id: '647dfd8fe43543e8f3179fc7',
  },
];

export default function(props){
  const productTemplate = (product) => {
    return (
      <div className={'carouselPhotoWrapper'} onClick={() => props.goToCampaign(product.id)}>
        <Image src={product.photo} alt={'Campaign Photo'} width={'100%'} className={'carouselPhoto'}/>
      </div>
    );
  };

  const handleSwitch = () => {
    localStorage.setItem('new-design-toggle', 'deactivated');
    location.reload();
  }

  return (
    <div className={'new-dashboard'}>
      <div className={'oldDesignSwitch'}>
        <div className={'oldDesignSwitchTopRow'}>
          <WarningCircleIcon/>
          You are now in the new version of G.IO.
        </div>
        <Button className={'oldDesignSwitchButton'} onClick={() => handleSwitch()}>Switch to the old version</Button>
      </div>
      <div className={'whiteBg'}>
        <p className={'redTitle'}>Welcome back, {props.user.name}</p>
        {props.viewPerspective === Perspective.BRAND && <p className={'smallText'}>From here you can check out creators, content items, running campaigns or create a new campaign!</p>}
        {props.viewPerspective === Perspective.CREATOR && <p className={'smallText'}>From here you can check out new campaigns, create content, keep track of your earnings and license requests!</p>}
      </div>
      <div className={'latestCampaigns'}>
        <p className={'labelCampaigns'}>Latest Campaigns</p>
        <Carousel value={products} numVisible={1} numScroll={1} itemTemplate={productTemplate} autoplayInterval={6000}/>
      </div>
      <div className={'latestInfluencers'}>
        <div className={'labelRow'}>
          <p className={'label'}>Latest Influencers</p>
          <p className={'seeAll'} onClick={() => props.handleRouting('app/creators')}>See All</p>
        </div>
        <div className={'latestInfluencersGrid'}>
          {props.latestInfluencers?.map((item, index) =>
            <div key={index} className={'influencerItem'}>
              <NewInfluencerItem influencer={item} goToProfile={props.goToInfluencerProfile}
                                 addToFavorites={props.addToFavorites} favorites={props.favorites}/>
            </div>)}
        </div>
      </div>
      <div className={'activeCampaigns'}>
        <div className={'labelRow'}>
          <p className={'label'}>Active Campaigns</p>
          <p className={'seeAll'}>See All</p>
        </div>
        <div className={'activeCampaignsGrid'}>
          {props.activeCampaigns?.map((item, index) =>
            <div key={index} className={'campaignWrapper'}>
                <NewActiveCampaignItem campaign={item} goToCampaign={props.goToCampaign}/>
            </div>)}
        </div>
      </div>
    </div>
  )
}
